import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Home from './Pages/Home'
import Navbar from './Components/NavBar'
import Footer from './Components/Footer'
import AboutUsPage from './Pages/AboutUsPage'
import ServicePage from './Pages/ServicePage'
import ContactPage from './Pages/ContactUsPage'

const App = () => {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutUsPage />} />

        <Route path="/services/networking-amc" element={<ServicePage serviceSlug="networking-amc" />} />
        <Route path="/services/computer-amc" element={<ServicePage serviceSlug="computer-amc" />} />
        <Route path="/services/laptop-amc" element={<ServicePage serviceSlug="laptop-amc" />} />
        <Route path="/services/server-amc" element={<ServicePage serviceSlug="server-amc" />} />
        <Route path="/services/projector-amc" element={<ServicePage serviceSlug="projector-amc" />} />
        <Route path="/services/cctv-amc" element={<ServicePage serviceSlug="cctv-amc" />} />
        <Route path="/services/cctv-installation" element={<ServicePage serviceSlug="cctv-installation" />} />
        <Route path="/services/it-services" element={<ServicePage serviceSlug="it-services" />} />

        <Route path="/contact" element={<ContactPage />} />

      </Routes>
      <Footer />
    </Router>
  )
}

export default App